export const CALENDAR_ROOT = "/calendar";